// extracted by mini-css-extract-plugin
export default {"RecipeCardField":"RecipeCard_RecipeCardField__u+Xe-"};